// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1NoUG","right":"styles_right__3Kyg9"};